/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/layout/Main'
import store from '@/store'
import VueCookies from 'vue-cookies'
import { userLogin } from '@/utils/user'
import { getTitle, getLangPath } from '@/utils/tool'
import { $langt } from '@/utils/i18n'

Vue.use(Router)

// 語系相對路徑 //
const pathBase = getLangPath() === '' ? '' : ('/' + getLangPath())

export const routerMap = [
  {
    path: pathBase + '/',
    redirect: pathBase + '/index'
  },
  {
    component: Main,
    path: pathBase + '/',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index'),
        meta: { needLogin: false, menuName: 'index' },
        name: 'Index'
      }
    ]
  },
  {
    component: Main,
    path: pathBase + '/user',
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: () => import('@/views/user/index'),
        meta: { needLogin: false, menuName: 'user', title: () => $langt('帳號') },
        name: 'UserIndex'
      },
      {
        path: 'info',
        component: () => import('@/views/user/info'),
        meta: { needLogin: true, menuName: 'user', title: () => $langt('個人資訊') },
        name: 'UserInfo'
      },
      {
        path: 'edit',
        component: () => import('@/views/user/edit'),
        meta: { needLogin: true, menuName: 'user', title: () => $langt('編輯個人資訊') },
        name: 'UserEdit'
      },
      {
        path: 'cancel-policy',
        component: () => import('@/views/user/cancel_policy'),
        meta: { needLogin: false, menuName: 'user', title: () => $langt('取消政策') },
        name: 'UserCancelPolicy'
      },
      {
        path: 'person-policy',
        component: () => import('@/views/user/person_policy'),
        meta: { needLogin: false, menuName: 'user', title: () => $langt('隱私聲明') },
        name: 'UserPersonPolicy'
      },
      {
        path: 'policy',
        redirect: '/user/person-policy'
        // component: () => import('@/views/user/policy'),
        // meta: { needLogin: false, menuName: 'user', title: () => $langt('隱私權政策') },
        // name: 'Policy'
      },
      {
        path: 'about',
        component: () => import('@/views/user/about'),
        meta: { needLogin: false, menuName: 'user', title: () => $langt('關於我們') },
        name: 'UserAbout'
      },
      {
        path: 'faq',
        component: () => import('@/views/user/faq'),
        meta: { needLogin: false, menuName: 'faq', title: () => $langt('常見問答') },
        name: 'UserFaq'
      },
      {
        path: 'otp',
        component: () => import('@/views/user/otp'),
        meta: {},
        name: 'Otp'
      },
      {
        path: 'hgsso/:redirect?',
        component: () => import('@/views/user/happygo_sso'),
        meta: { needLogin: false },
        name: 'HappyGoSSO'
      },
      {
        path: 'hgsso-return/:redirect?',
        component: () => import('@/views/user/happygo_sso_return'),
        meta: { needLogin: false },
        name: 'HappyGoSSOReturn'
      },
      {
        path: 'sso',
        component: () => import('@/views/user/sso'),
        meta: { needLogin: false },
        name: 'SSO'
      },
      {
        path: 'sso-return',
        component: () => import('@/views/user/sso_return'),
        meta: { needLogin: false },
        name: 'SSOReturn'
      },
      {
        path: 'sso-accept',
        component: () => import('@/views/user/sso_accept'),
        meta: { needLogin: false },
        name: 'SSOAccept'
      },
      {
        path: 'login',
        component: () => import('@/views/user/login'),
        meta: {},
        name: 'Login'
      },
      {
        path: 'loginindex/:redirect?',
        component: () => import('@/views/user/loginindex'),
        meta: { needLogin: false },
        name: 'LoginIndex'
      },
      {
        path: 'prompt',
        component: () => import('@/views/user/prompt'),
        meta: { needLogin: false, title: () => $langt('登入提示') },
        name: 'Prompt'
      },
      {
        path: 'twmsso/:redirect?',
        component: () => import('@/views/user/twm_sso'),
        meta: { needLogin: false },
        name: 'TwmSSO'
      }
    ]
  },
  {
    component: Main,
    path: pathBase + '/product',
    children: [
      {
        path: '',
        component: () => import('@/views/product/index'),
        meta: { needLogin: false, menuName: 'product' },
        name: 'ProductIndex',
        beforeEnter: (to, from, next) => {
          // 若不是從明細頁返回, 清除搜尋紀錄
          if (from.name !== 'ProductDetail') {
            (async() => {
              await store.dispatch('clearSearchRecord')
            })()
          }
          next()
        }
      },
      {
        path: 'keyword/:keyword',
        component: () => import('@/views/product/index'),
        meta: { needLogin: false, menuName: 'index' },
        name: 'ProductKeyword',
        beforeEnter: (to, from, next) => {
          // 若不是從明細頁返回, 清除搜尋紀錄
          if (from.name !== 'ProductDetail') {
            (async() => {
              await store.dispatch('clearSearchRecord')
            })()
          }
          next()
        }
      },
      {
        path: 'cate/:cate',
        component: () => import('@/views/product/index'),
        meta: { needLogin: false, menuName: 'index' },
        name: 'ProductCate',
        beforeEnter: (to, from, next) => {
          // 若不是從明細頁返回, 清除搜尋紀錄
          if (from.name !== 'ProductDetail') {
            (async() => {
              await store.dispatch('clearSearchRecord')
            })()
          }
          next()
        }
      },
      {
        path: 'area/:area',
        component: () => import('@/views/product/index'),
        meta: { needLogin: false, menuName: 'index' },
        name: 'ProductArea',
        beforeEnter: (to, from, next) => {
          // 若不是從明細頁返回, 清除搜尋紀錄
          if (from.name !== 'ProductDetail') {
            (async() => {
              await store.dispatch('clearSearchRecord')
            })()
          }
          next()
        }
      },
      {
        path: 'detail/:id?/:cate?',
        component: () => import('@/views/product/detail'),
        meta: { needLogin: false, menuName: 'index' },
        name: 'ProductDetail'
      }
    ]
  },
  {
    component: Main,
    path: pathBase + '/order',
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: () => import('@/views/order/index'),
        meta: { needLogin: true, menuName: 'order', title: () => $langt('訂單列表') },
        name: 'OrderIndex'
      },
      {
        path: 'detail/:num?',
        component: () => import('@/views/order/detail'),
        meta: { menuName: 'order', title: () => $langt('訂單內容') },
        name: 'OrderDetail'
      },
      {
        path: 'init',
        component: () => import('@/views/order/init'),
        meta: { menuName: 'order', title: () => $langt('訂購確認') },
        name: 'OrderInit'
      },
      {
        path: 'user-info',
        component: () => import('@/views/order/user-info'),
        meta: { menuName: 'order', title: () => $langt('訂購填寫') },
        name: 'OrderUserInfo'
      },
      {
        path: 'finish',
        component: () => import('@/views/order/finish'),
        meta: { menuName: 'order', title: () => $langt('訂購完成') },
        name: 'OrderFinish'
      },
      {
        path: 'fail',
        component: () => import('@/views/order/fail'),
        meta: { menuName: 'order' },
        name: 'OrderFail'
      },
      {
        path: 'qrcode/:code?/:payment?/:id?',
        component: () => import('@/views/order/paymentqrcode'),
        meta: { menuName: 'qrcode' },
        name: 'qrcodeView'
      },
      {
        path: 'checkPaid',
        component: () => import('@/views/order/checkPaid'),
        meta: { menuName: 'order' },
        name: 'checkPaid'
      }
    ]
  },
  {
    // 票券
    component: Main,
    path: pathBase + '/voucher',
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: () => import('@/views/voucher/index'),
        meta: { needLogin: true, menuName: 'voucher', title: () => $langt('票夾列表') },
        name: 'Voucher'
      },
      {
        path: 'mode/:mode/:cate?',
        component: () => import('@/views/voucher/index'),
        meta: { needLogin: true, menuName: 'voucher' },
        name: 'VoucherMode'
      },
      {
        path: 'detail/:num?/:cate?',
        component: () => import('@/views/voucher/detail'),
        meta: { menuName: 'voucher', title: () => $langt('票券內容') },
        name: 'VoucherDetail'
      }
    ]
  },
  {
    component: Main,
    path: pathBase + '/language',
    children: [
      {
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        component: () => import('@/views/language/index'),
        meta: { needLogin: false, menuName: 'language', title: () => $langt('語系') },
        name: 'Language'
      }
    ]
  },
  {
    component: Main,
    path: pathBase + '/contact',
    children: [
      {
        path: '',
        redirect: 'ask'
      },
      {
        path: 'ask/:order_num?',
        component: () => import('@/views/contact/ask'),
        meta: { menuName: 'user', title: () => $langt('聯絡我們') },
        name: 'ContactAsk'
      }
    ]
  },
  {
    path: pathBase + '/close',
    component: () => import('@/views/close'),
    name: 'Close'
  },
  {
    path: pathBase + '/error',
    component: () => import('@/views/error'),
    name: 'Error'
  },
  {
    path: pathBase + '*',
    redirect: pathBase + '/error',
    hidden: true
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0, behavior: 'instant' }),
  routes: routerMap
})

/**
 * 在確認為網站內部的路徑時，檢查補上語系。
 * @param {string} path 要轉換的路徑
 * @returns
 */
router.langPath = (path) => {
  if (path.substring(0, 7) === 'http://' || path.substring(0, 8) === 'https://') {
    // 完整 uri ，在 hostname 與 port 相同的情況下才進行 語系轉換 //
    var url = new URL(path)
    if (url.host !== window.location.host) {
      return path
    }
    if (pathBase !== '' && url.pathname.substring(0, pathBase.length) !== pathBase) {
      url.pathname = pathBase + url.pathname
      return url.toString()
    }
    return path
  } else if (path.substring(0, 1) === '/') {
    // 絕對路徑 //
    return (pathBase !== '' && path.substring(0, pathBase.length) !== pathBase) ? pathBase + path : path
  } else {
    // 相對路徑不轉換 //
    return path
  }
}

// 需要登入的頁面判斷
router.beforeEach((to, from, next) => {
  // 依照語系檢查轉址 //
  if (pathBase !== '' && to.path.substring(0, pathBase.length) !== pathBase) {
    next({ path: pathBase + to.path, params: to.params, query: to.query })
    return
  }

  // 設定 Title 資訊
  if (to.name === 'Index') {
    getTitle()
  } else if (to.name !== 'ProductCate' || to.name !== 'ProductDetail') {
    getTitle(to.meta.title ? to.meta.title() : '')
  }
  if (to.meta) {
    if (
      to.meta.needLogin &&
      (!store.getters.authInfo.token || !store.getters.authInfo.third_verify)
    ) {
      // 沒token直接sso
      userLogin(to)
    }
    // else if (to.meta.needLogin && !store.getters.authInfo.third_verify) {
    //   userLogin(to)
    //   // 有token但需要otp
    //   // router.push({ path: '/user/otp' }).catch(() => {
    //   // })
    // }
  }
  // 攜帶 partner 參數
  if (from.query.partner && !to.query.partner) {
    to.query.partner = from.query.partner
    next(to)
  }
  // from sso login or to fail/finish
  if (
    VueCookies.get('partner_code') &&
    !to.query.partner &&
    !from.query.partner
  ) {
    to.query.partner = VueCookies.get('partner_code')
    next(to)
  }
  // 若使用者未關閉彈出直接返回,移除overflow 屬性
  if (to.name === 'ProductCate') {
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = ''
    }
  }
  next()
})
export default router
